import { apiClient } from "@/lib/api-client";

export type ConfigPersentase = {
  persentase_bkd: number;
  persentase_iku: number;
};

export type ConfigPersentaseResponse = {
  config: ConfigPersentase;
  message: string;
};

export const getConfigPersentase = async (): Promise<ConfigPersentase> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const resData = await apiClient<ConfigPersentaseResponse>(
    `${baseUrl}/api/v1/config/persentase`,
    {
      headers: {
        Accept: "application/json",
      },
    },
  );
  return resData.config;
};
